import {
  apply,
  applyEach,
  applyWhenValue,
  maxLength,
  minLength,
  pattern,
  required,
  schema,
  validate,
} from '@angular/forms/signals';
import { ContactInfo, ContactWrapper } from '../types';

export const contactInfoSchema = schema<ContactInfo>((schemaPath) => {
  /*
   * @NOTE: Validating email
   * */
  applyWhenValue(
    schemaPath,
    (t) => t.type === 'email',
    (p) => required(p.contact, { message: 'Email is required' }),
  );
  applyWhenValue(
    schemaPath,
    (t) => t.type === 'email',
    (p) =>
      pattern(
        p.contact,
        /^(?=.{1,254}$)(?=.{1,64}@)(?=[^@]*[A-Za-z])[A-Za-z0-9](?:[A-Za-z0-9._%+'-]{0,62}[A-Za-z0-9])?@(?:[A-Za-z](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])\.)+[A-Za-z]{2,63}$/,
        { message: 'Please enter a valid email address' },
      ),
  );
  /*
   * @NOTE: Validating email end
   * */
  /**
   * @NOTE Validatig phone number start
   */
  applyWhenValue(
    schemaPath,
    (t) => t.type === 'phone',
    (p) => required(p.contact, { message: 'Phone number is required' }),
  );
  applyWhenValue(
    schemaPath,
    (t) => t.type === 'phone',
    (p) =>
      pattern(p.contact, /^[\d\s\-()]+$/, {
        message: 'Phone number must contain only numeric value',
      }),
  );

  applyWhenValue(
    schemaPath,
    (t) => t.type === 'phone',
    (p) =>
      validate(p.countryCode, (ctx) => {
        const _countryCode = ctx.value();
        const _contact = ctx.valueOf(p.contact);

        if (_countryCode?.label?.toLowerCase() === 'select country code') {
          return { kind: 'country code', message: 'Country Code is required' };
        }

        if (
          _contact?.length >= 10 &&
          (!_countryCode || _countryCode?.label?.length === 0)
        ) {
          return { kind: 'country code', message: 'Country Code is required' };
        }

        return null;
      }),
  );
  applyWhenValue(
    schemaPath,
    (t) => t.type === 'phone',
    (p) =>
      maxLength(p.contact, 15, {
        message: 'Phone number cannot exceed 15 digits',
      }),
  );
  applyWhenValue(
    schemaPath,
    (t) => t.type === 'phone',
    (p) =>
      minLength(p.contact, 10, {
        message: 'Phone number must be at least 10 digits',
      }),
  );
  /*
   * @NOTE: Validating phone number end
   * */
});

export const contactFormSchema = schema<ContactWrapper>((schemaPath) => {
  apply(schemaPath.contactForm, contactInfoSchema);
  applyEach(schemaPath.assignedContacts, (contact) =>
    apply(contact, contactInfoSchema),
  );
});
